import { Template } from '../types/templates';
import { getReportItems as getAssetEndOfLifeReportItems } from './generators/assetEndOfLife';
import { getReportItems as getIpAddressReportItems } from './generators/ipAddressReport';
import { getReportItems as getServiceQuotaAndLimitsReportItems } from './generators/serviceQuotaAndLimitsReport';
import { getReportItems as getUserAccessReviewReportItems } from './generators/userAccessReview';
import assetEndOfLife from './yamls/asset-end-of-life.yml?raw';
import awsBackupHealth from './yamls/aws-backup-health.yml?raw';
import awsCloudDataSecurityOverview from './yamls/aws-cloud-data-security-overview.yml?raw';
import awsCloudtrailLogDetections from './yamls/aws-cloudtrail-log-detections.yml?raw';
import awsCostAndUsage from './yamls/aws-cost-and-usage.yml?raw';
import awsSecretsReport from './yamls/aws-secrets-report.yml?raw';
import awsSecurityBestPractices from './yamls/aws-security-best-practicies.yml?raw';
import awsSecurityHubOverview from './yamls/aws-security-hub-overview.yml?raw';
import awsVpcDetails from './yamls/aws-vpc-details.yml?raw';
import awsWellArchitected from './yamls/aws-well-architected.yml?raw';
import azureAttackSurfaceSecurityPosture from './yamls/azure-attack-surface-security-posture.yml?raw';
import costSavingOpportunities from './yamls/cost-savings-opportunities.yml?raw';
import githubRepositoryInsights from './yamls/github-repository-insights.yml?raw';
import githubSecurityInsights from './yamls/github-security-insights.yml?raw';
import identityAndAccessOverview from './yamls/identity-and-access-overview.yml?raw';
import ipAddressReport from './yamls/ip-address-report.yml?raw';
import k8sContainerReport from './yamls/k8s-container-report.yml?raw';
import multiCloudAssetInventory from './yamls/multi-cloud-asset-inventory.yml?raw';
import serviceQuotaAndLimitsReport from './yamls/service-quota-and-limits-report.yml?raw';
import simpleBoilerplate from './yamls/simple-boilerplate.yml?raw';
import tagsOverview from './yamls/tags-overview.yml?raw';
import userAccessReview from './yamls/user-access-review.yml?raw';
// TODO: this should all be API driven for v2
// for v1 we want to control the templates on the frontend to quickly update them from feedback
// once they are stable we can move them to the backend as fixtures for each tenant.

export const buildYourOwnTemplate: Template = {
  id: 'build-your-own',
  title: 'build-your-own',
  yaml: simpleBoilerplate,
};

export const templates: Template[] = [
  {
    generator: getAssetEndOfLifeReportItems,
    id: '7dc0addd-1484-4a6b-95bf-c9718901bf0e',
    title: 'asset-end-of-life',
    yaml: assetEndOfLife,
  },
  {
    id: '8f9d1e13-9dd8-438d-aba9-35e8218711dc',
    title: 'aws-backup-health',
    yaml: awsBackupHealth,
  },
  {
    id: '48dfd896-d3f1-4770-95f5-244353856878',
    title: 'aws-cloud-data-security-overview',
    yaml: awsCloudDataSecurityOverview,
  },
  {
    id: 'cb2c5a82-c14e-474f-9b61-e8ab3f53f784',
    title: 'aws-cloudtrail-log-detections',
    yaml: awsCloudtrailLogDetections,
  },
  {
    id: 'cf4ea4cd-4b85-49e2-aba6-8c51b8cdb9fc',
    title: 'aws-cost-and-usage',
    yaml: awsCostAndUsage,
  },
  {
    id: 'fdbdeaf9-9bff-44b7-9707-371a28a386fa',
    title: 'aws-security-best-practices',
    yaml: awsSecurityBestPractices,
  },
  {
    id: '6878bc40-8845-458c-be27-656f19160a26',
    title: 'aws-secrets-report',
    yaml: awsSecretsReport,
  },
  {
    id: '596613a6-0c62-457c-a529-a22e4500618d',
    title: 'aws-security-hub-overview',
    yaml: awsSecurityHubOverview,
  },
  {
    id: '91e1a623-3e86-4d14-8fd9-0b898a8cd1ac',
    title: 'aws-vpc-details',
    yaml: awsVpcDetails,
  },
  {
    id: '51f075c7-7a3c-4c5d-91c7-5ffe17c32026',
    title: 'aws-well-architected',
    yaml: awsWellArchitected,
  },
  {
    id: '0eed263e-df8a-4e98-964d-988ca62ab3d8',
    title: 'azure-attack-surface-security-posture',
    yaml: azureAttackSurfaceSecurityPosture,
  },
  {
    id: '3b99e024-a93a-4616-a482-0f3cee9bdd45',
    title: 'cost-saving-opportunities',
    yaml: costSavingOpportunities,
  },
  {
    id: '44405bfa-e896-446d-9adc-0705096267ba',
    title: 'github-repository-insights',
    yaml: githubRepositoryInsights,
  },
  {
    id: 'c19c5e0a-e4f0-4385-8384-8d67a17b0f4f',
    title: 'github-security-insights',
    yaml: githubSecurityInsights,
  },
  {
    id: '84b71ee0-dd1d-408c-888e-ab4f31805873',
    title: 'identity-and-access-overview',
    yaml: identityAndAccessOverview,
  },
  {
    generator: getIpAddressReportItems,
    id: '1ca9cf54-d52f-43f8-ae9e-98e78a7a87ab',
    title: 'ip-address-report',
    yaml: ipAddressReport,
  },
  {
    id: '6f8c5b2e-9fe2-4a4f-be76-00ad04890e16',
    title: 'kubernetes-container-report',
    yaml: k8sContainerReport,
  },
  {
    id: 'eaa27908-c821-4f42-b469-b7a270fada7f',
    title: 'multi-cloud-asset-inventory',
    yaml: multiCloudAssetInventory,
  },
  {
    generator: getServiceQuotaAndLimitsReportItems,
    id: '53e38c90-fa71-4731-aa01-68470db535eb',
    title: 'service-quota-and-limits-report',
    yaml: serviceQuotaAndLimitsReport,
  },
  {
    id: '46c1f00d-f25d-4d78-8de0-7d723076eeeb',
    title: 'tags-overview',
    yaml: tagsOverview,
  },
  {
    generator: getUserAccessReviewReportItems,
    id: 'fbb430b7-24c3-4505-b931-b3fabeb885ac',
    title: 'user-access-review',
    yaml: userAccessReview,
  },
];
